
<div style="color: #0000003b">

	<div class="footerLinks">
		<a [routerLink]="['/Impressum']" style="color: #0000003b;">Impressum</a>
		|
		<a [routerLink]="['/Kontakt']" style="color: #0000003b;">Kontakt</a>

		@if( environment.features.payments ) {
    |
    	<a [routerLink]="['/auth/plans']" style="color: #0000003b;">Preise</a>
			}
	</div>
	

	<div style="text-align: center;">
		<a href="https://www.trivelope.de/" class="trivLink">
			<div>
				v{{version}} - Entwickelt durch die trivelope GmbH
			</div>
			<img
				src="assets/logo_trivelope.png"
				style="max-width: 10em; margin: 1em 0;"
			>
		</a>
	</div>

</div>
